// extracted by mini-css-extract-plugin
module.exports = {"channelDetails":"ChannelDetails_channelDetails__1cnGw","channelDetails_profile":"ChannelDetails_channelDetails_profile__w30V5"};